import * as React from 'react'
import {ReactElement} from 'react'
import {Nullable} from '../../app/TypeHelpers'
import {ADMINISTORATOR_MODE, MESSAGE_TYPE, SELECT_CONDOMINIUM_TYPE} from '../../CodeMaster'
import {Messages} from '../../Messages'
import EventEmitterExAdmin from '../shared/pageBaseComponents/EventEmitterExAdmin'
import {CondominiumInfo} from '../../__NoAutomatedTests/components/condominium/repository/NatGetCondominiumList'
import NatCondominiumRepo from '../../__NoAutomatedTests/components/condominium/repository/NatCondominiumRepo'
import NatCondominiumGroupRepo from '../../__NoAutomatedTests/components/condominiumGroup/repository/NatCondominiumGroupRepo'
import NatMenuMasterRepo from '../../__NoAutomatedTests/components/menuMaster/repository/NatMenuMasterRepo'
import NatSessionRepo from '../../__NoAutomatedTests/components/session/repository/NatSessionRepo'
import equal from 'fast-deep-equal'
import {AsyncCommunicationProps, withAsyncCommunication} from '../shared/hoc/withAsyncCommunication'
import {
    AdminLoginInfoSessionStorageKey,
    NatAdminLoginInfoSessionStorageHelper,
} from '../../__NoAutomatedTests/common/authentication/NatAdminLoginInfoSessionStorageHelper'
import NatAdminUserRepo from '../../__NoAutomatedTests/components/adminUser/repository/NatAdminUserRepo'
import {AdminUserRelatedCondominiumGroup} from '../../__NoAutomatedTests/components/adminUser/repository/AdminUserRelatedCondominiumGroup'
import NatCurrentDateTimeRepo from '../../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import {NatGetCurrentDateTime} from '../../__NoAutomatedTests/components/currentDateTime/repository/NatGetCurrentDateTime'
import moment, {Moment} from 'moment'
import NatCondominiumSelectionComponent
    from '../../__NoAutomatedTests/components/common/admin/NatCondominiumSelectionComponent'
import NatAdminHeaderAreaComponentPc from './AdminHeaderAreaComponentPc'
import {AppAdminContext} from '../../app/AppAdminContext'
import NatAdminHeaderAreaComponentSp from './AdminHeaderAreaComponentSp'
import {ADMIN_LOGIN_PORTAL_PATH, AdminSessionUtil} from '../../app/AdminSessionUtil'
import {Location} from 'react-router-dom'
import {RouterPageProps} from '../shared/RouterPropsInjector'
import NatResidentUserRepo from '../../__NoAutomatedTests/components/residentUser/repository/NatResidentUserRepo';

const ADMIN_LOGIN_PAGE_PATH = '/admin/login'
const ADMIN_ASSOC_LOGIN_PAGE_PATH = '/admin/assoc/login'
const ADMIN_ASSOC_LOGIN_REDIRECT_CUSHION_PATH = '/admin/assoc/loginRedirectCushion'

const NO_AUTHENTICATION_REQUIRED_URL_LIST = [
    ADMIN_LOGIN_PORTAL_PATH,
    ADMIN_LOGIN_PAGE_PATH,
    ADMIN_ASSOC_LOGIN_PAGE_PATH,
    '/admin/sso/azure/redirect',
    '/admin/error',
    ADMIN_ASSOC_LOGIN_REDIRECT_CUSHION_PATH
]

interface Props {
    loginedFlg: boolean
    condominiumRepo: NatCondominiumRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    adminUserRepo: NatAdminUserRepo
    menuMasterRepo: NatMenuMasterRepo
    sessionRepo: NatSessionRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
    adminSessionUtil: AdminSessionUtil,
    residentUserRepo: NatResidentUserRepo
}

interface States {
    mode: Nullable<string>
    selectedCondominiumName: Nullable<string>
    loginUserInfo: LoginUserInfo
    adminUserRelatedCondominiumGroupInfo: Nullable<AdminUserRelatedCondominiumGroupInfo>
    currentDateTime: Nullable<Moment>
    isOpenDialogSelectCondominium: boolean
    isOpenDialogSelectCondominiumWithSwitchedGroup: boolean
}

export interface AdminUserRelatedCondominiumGroupInfo {
    belongCondominiumGroup: CondominiumGroup,
    subCondominiumGroup: Nullable<CondominiumGroup>,
    endDateOfSubCondominiumGroup: Nullable<Moment>,
}

export interface CondominiumGroup {
    id: number
    name: string
}

export interface LoginUserInfo {
    loginUserCondominiumGroupName: Nullable<string>
    loginUserCondominiumGroupId: Nullable<number>
    loginUserAdminId: Nullable<string>
    loginUserAdminFamilyName: Nullable<string>
    loginUserAdminFirstName: Nullable<string>
    roleId: Nullable<string>
    roleName: Nullable<string>
    isBelongCondominiumGroup: boolean
}

class AdminHeaderAreaComponent extends React.Component<Props & AsyncCommunicationProps & RouterPageProps, States> {
    declare context: React.ContextType<typeof AppAdminContext>
    constructor(props: Props & AsyncCommunicationProps & RouterPageProps) {
        super(props)

        if (sessionStorage.length < 1 &&
            !NO_AUTHENTICATION_REQUIRED_URL_LIST.find(noAuthenticationRequiredUrl =>
                noAuthenticationRequiredUrl.match(this.props.location.pathname))
        ) {
            window.location.href = `/admin/login?seniurl=${this.props.location.pathname}`
        }

        const loginUserCondominiumName = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_NAME)
        const loginUserCondominiumGroupName = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_NAME)
        const loginUserCondominiumGroupId = NatAdminLoginInfoSessionStorageHelper.getNumberItemOrNull(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_ID)
        const loginUserAdminId = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_ADMIN_ID)
        const loginUserAdminFamilyName = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_FAMILY_NAME)
        const loginUserAdminFirstName = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_FIRST_NAME)
        const roleId = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_ROLE_ID)
        const roleName = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.LOGIN_USER_ROLE_NAME)
        const isBelongCondominiumGroup = !loginUserCondominiumName

        const loginUserInfo: LoginUserInfo = {
            loginUserCondominiumGroupName,
            loginUserCondominiumGroupId,
            loginUserAdminId,
            loginUserAdminFamilyName,
            loginUserAdminFirstName,
            roleId,
            roleName,
            isBelongCondominiumGroup,
        }
        this.state = {
            selectedCondominiumName: NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
                AdminLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME),
            mode: NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
                AdminLoginInfoSessionStorageKey.SELECTED_MODE),
            loginUserInfo: loginUserInfo,
            adminUserRelatedCondominiumGroupInfo: null,
            currentDateTime: null,
            isOpenDialogSelectCondominium: false,
            isOpenDialogSelectCondominiumWithSwitchedGroup: false,
        }

        this.handleClickAllMode = this.handleClickAllMode.bind(this)
        this.handleClickOkOnAllModeDialog = this.handleClickOkOnAllModeDialog.bind(this)
        this.handleClickCancelOnDialog = this.handleClickCancelOnDialog.bind(this)
        this.handleClickCondominiumMode = this.handleClickCondominiumMode.bind(this)
        this.handleClickOkOnCondominiumModeDialog = this.handleClickOkOnCondominiumModeDialog.bind(this)
        this.handleLogoutClick = this.handleLogoutClick.bind(this)
        this.handleSetSelectedCondominiumInfo = this.handleSetSelectedCondominiumInfo.bind(this)
        this.handleCloseSelectCondominiumDiaLog = this.handleCloseSelectCondominiumDiaLog.bind(this)
        this.handleClickCondominiumGroupSwitchingLink =
            this.handleClickCondominiumGroupSwitchingLink.bind(this)
        this.handleClickOkOnSwitchingCondominiumGroupDialogInSelectedCondominiumMode =
            this.handleClickOkOnSwitchingCondominiumGroupDialogInSelectedCondominiumMode.bind(this)
        this.hasValidSubCondominiumGroup = this.hasValidSubCondominiumGroup.bind(this)
        this.getSwitchingCondominiumGroup = this.getSwitchingCondominiumGroup.bind(this)
        this.handleChangeLoginSiteToResidentButtonClick = this.handleChangeLoginSiteToResidentButtonClick.bind(this)
        this.handleClickOkChangeLoginSiteToResident = this.handleClickOkChangeLoginSiteToResident.bind(this)
        this.closeSelectCondominiumDialog = this.closeSelectCondominiumDialog.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const {loginUserAdminId} = this.state.loginUserInfo

        if (!this.props.loginedFlg) {
            await this.props.asyncCallFunction(
                this.props.sessionRepo.postAdminUseSite.bind(this.props.sessionRepo),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
        }

        if (!loginUserAdminId) {
            return
        }

        if (window.location.pathname === '/admin/assoc/login' ||
            window.location.pathname === '/admin/login' ||
            window.location.pathname === '/admin/login-portal' ||
            window.location.pathname === '/admin/error') {
            return;
        }

        const adminUserRelatedCondominiumGroupInfo = await this.getAdminUserRelatedCondominiumGroup(loginUserAdminId)
        if (adminUserRelatedCondominiumGroupInfo === null) {
            return
        }

        const currentDateTime = await this.getCurrentDateTime()
        if (currentDateTime === null) {
            return
        }

        this.setState({adminUserRelatedCondominiumGroupInfo, currentDateTime})
    }


    async componentDidUpdate(prevProps: Props, prevState: States): Promise<void> {
        if (!this.props.loginedFlg) {
            await this.props.asyncCallFunction(
                this.props.sessionRepo.postAdminUseSite.bind(this.props.sessionRepo),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
        }
        if (!equal(prevProps.loginedFlg, this.props.loginedFlg)) {
            const selectedCondominiumName = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
                AdminLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME)
            const mode = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
                AdminLoginInfoSessionStorageKey.SELECTED_MODE)
            const loginUserCondominiumName = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
                AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_NAME)
            const loginUserCondominiumGroupName = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
                AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_NAME)
            const loginUserCondominiumGroupId = NatAdminLoginInfoSessionStorageHelper.getNumberItemOrNull(
                AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_ID)
            const loginUserAdminId = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
                AdminLoginInfoSessionStorageKey.LOGIN_USER_ADMIN_ID)
            const loginUserAdminFamilyName = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
                AdminLoginInfoSessionStorageKey.LOGIN_USER_FAMILY_NAME)
            const loginUserAdminFirstName = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
                AdminLoginInfoSessionStorageKey.LOGIN_USER_FIRST_NAME)
            const roleId = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
                AdminLoginInfoSessionStorageKey.LOGIN_USER_ROLE_ID)
            const roleName = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
                AdminLoginInfoSessionStorageKey.LOGIN_USER_ROLE_NAME)
            const isBelongCondominiumGroup = !loginUserCondominiumName

            const loginUserInfo: LoginUserInfo = {
                loginUserCondominiumGroupName,
                loginUserCondominiumGroupId,
                loginUserAdminId,
                loginUserAdminFamilyName,
                loginUserAdminFirstName,
                roleId,
                roleName,
                isBelongCondominiumGroup,
            }

            if (!loginUserAdminId) {
                this.setState({
                    selectedCondominiumName: selectedCondominiumName,
                    mode: mode,
                    loginUserInfo: loginUserInfo,
                    adminUserRelatedCondominiumGroupInfo: null,
                    isOpenDialogSelectCondominium: false,
                    isOpenDialogSelectCondominiumWithSwitchedGroup: false,
                    currentDateTime: null,
                })

                return
            }

            const currentDateTime = await this.getCurrentDateTime()
            if (currentDateTime === null) {
                return
            }

            const adminUserRelatedCondominiumGroupInfo =
                await this.getAdminUserRelatedCondominiumGroup(loginUserAdminId)
            if (adminUserRelatedCondominiumGroupInfo === null) {
                return
            }

            this.setState({
                selectedCondominiumName: selectedCondominiumName,
                mode: mode,
                loginUserInfo: loginUserInfo,
                adminUserRelatedCondominiumGroupInfo: adminUserRelatedCondominiumGroupInfo,
                currentDateTime: currentDateTime,
                isOpenDialogSelectCondominium: false,
            })
        }
    }

    async getCurrentDateTime(): Promise<Nullable<Moment>> {
        const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
            this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        if (!currentDateTime || !currentDateTime.details) {
            return null
        }
        return moment(currentDateTime.details.currentDateTime)
    }

    async getAdminUserRelatedCondominiumGroup(
        adminId: string,
    ): Promise<Nullable<AdminUserRelatedCondominiumGroupInfo>> {
        const condominiumGroupInfo: Nullable<AdminUserRelatedCondominiumGroup>
            = await this.props.asyncCallFunction(
            this.props.adminUserRepo.getAdminUserRelatedCondominiumGroup.bind(
                this.props.adminUserRepo, adminId,
            ),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )

        if (!condominiumGroupInfo) {
            return null
        }

        const endDateMoment: Nullable<Moment> =
            !condominiumGroupInfo.endDateOfSubCondominiumGroup ? null
                : moment(condominiumGroupInfo.endDateOfSubCondominiumGroup + 'T23:59:59')
        const belongCondominiumGroup: CondominiumGroup = {
            id: condominiumGroupInfo.belongCondominiumGroupId,
            name: condominiumGroupInfo.belongCondominiumGroupName,
        }
        let subCondominiumGroup: Nullable<CondominiumGroup> = null
        if (condominiumGroupInfo.subCondominiumGroupId &&
            condominiumGroupInfo.subCondominiumGroupName) {
            subCondominiumGroup = {
                id: condominiumGroupInfo.subCondominiumGroupId,
                name: condominiumGroupInfo.subCondominiumGroupName,
            }
        }

        return {
            belongCondominiumGroup,
            subCondominiumGroup,
            endDateOfSubCondominiumGroup: endDateMoment,
        }
    }

    // 有効な物件グループの引継設定があるかどうか
    hasValidSubCondominiumGroup(): boolean {
        const {adminUserRelatedCondominiumGroupInfo, currentDateTime} = this.state
        if (currentDateTime &&
            adminUserRelatedCondominiumGroupInfo &&
            adminUserRelatedCondominiumGroupInfo.subCondominiumGroup &&
            adminUserRelatedCondominiumGroupInfo.endDateOfSubCondominiumGroup &&
            currentDateTime.isSameOrBefore(adminUserRelatedCondominiumGroupInfo.endDateOfSubCondominiumGroup)
        ) {
            return true
        }
        return false
    }

    getSwitchingCondominiumGroup(): Nullable<CondominiumGroup> {
        const {adminUserRelatedCondominiumGroupInfo} = this.state
        const {loginUserCondominiumGroupId} = this.state.loginUserInfo
        if (!adminUserRelatedCondominiumGroupInfo) {
            return null
        }

        const {belongCondominiumGroup, subCondominiumGroup} = adminUserRelatedCondominiumGroupInfo

        if (!subCondominiumGroup) {
            return null
        }

        let switchingCondominiumGroup: CondominiumGroup
        if (loginUserCondominiumGroupId === subCondominiumGroup.id) {
            switchingCondominiumGroup = {
                id: belongCondominiumGroup.id,
                name: belongCondominiumGroup.name,
            }
        } else {
            switchingCondominiumGroup = {
                id: subCondominiumGroup.id,
                name: subCondominiumGroup.name,
            }
        }

        return switchingCondominiumGroup
    }

    async handleClickAllMode(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.WOPCA0001.errorLevel,
                message: Messages.WOPCA0001.toString('物件モード', '全体モード'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleClickCancelOnDialog,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleClickOkOnAllModeDialog,
                    },
                ],
            },
        )
    }

    async handleClickOkOnAllModeDialog(): Promise<void> {
        await this.props.adminSessionUtil.setAllMode(
            this.props,
            () => this.props.eventEmitter.closeDialog(),
        )
    }

    handleClickCancelOnDialog(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleClickCondominiumMode(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: this.state.mode === ADMINISTORATOR_MODE.ALL.value ?
                    Messages.WOPCA0001.errorLevel : Messages.WOPCA0002.errorLevel,
                message: this.state.mode === ADMINISTORATOR_MODE.ALL.value ?
                    Messages.WOPCA0001.toString('全体モード', '物件モード') : Messages.WOPCA0002.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleClickCancelOnDialog,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleClickOkOnCondominiumModeDialog,
                    },
                ],
            },
        )
    }

    handleClickOkOnCondominiumModeDialog(): void {
        this.props.eventEmitter.closeDialog()
        this.setState({isOpenDialogSelectCondominium: true})
    }

    handleCloseSelectCondominiumDiaLog(): void {
        this.closeSelectCondominiumDialog()
    }

    closeSelectCondominiumDialog(): void {
        this.setState({
            isOpenDialogSelectCondominium: false,
            isOpenDialogSelectCondominiumWithSwitchedGroup: false,
        })
    }

    async handleSetSelectedCondominiumInfo(selectedCondominiumInfo: CondominiumInfo): Promise<void> {
        await this.props.adminSessionUtil.setCondominiumMode(
            this.props,
            selectedCondominiumInfo,
            this.closeSelectCondominiumDialog,
        )
    }

    async handleClickCondominiumGroupSwitchingLink(): Promise<void> {
        const switchingCondominiumGroup = this.getSwitchingCondominiumGroup()
        if (!switchingCondominiumGroup) {
            return
        }

        const isAllMode = this.state.mode === ADMINISTORATOR_MODE.ALL.value

        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: isAllMode ? Messages.WOPCA0003.errorLevel
                    : Messages.WOPCA0004.errorLevel,
                message: isAllMode ? Messages.WOPCA0003.toString(switchingCondominiumGroup.name)
                    : Messages.WOPCA0004.toString(switchingCondominiumGroup.name),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleClickCancelOnDialog,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: isAllMode
                            ? this.handleClickOkOnSwitchingCondominiumGroupDialogInAllMode(switchingCondominiumGroup)
                            : this.handleClickOkOnSwitchingCondominiumGroupDialogInSelectedCondominiumMode(
                                switchingCondominiumGroup,
                            ),
                    },
                ],
            },
        )
    }

    handleClickOkOnSwitchingCondominiumGroupDialogInAllMode =
        (newCondominiumGroup: CondominiumGroup) => async () => {
            await this.props.adminSessionUtil.switchCondominiumGroup(
                this.props,
                newCondominiumGroup,
                () => {
                    this.props.eventEmitter.closeDialog()
                    this.props.adminSessionUtil.moveTopPage(this.props)
                },
            )
        }

    handleClickOkOnSwitchingCondominiumGroupDialogInSelectedCondominiumMode =
        (newCondominiumGroup: CondominiumGroup) => async () => {
            await this.props.adminSessionUtil.switchCondominiumGroup(
                this.props,
                newCondominiumGroup,
                () => {
                    this.props.eventEmitter.closeDialog()
                    this.setState({isOpenDialogSelectCondominiumWithSwitchedGroup: true})
                },
            )
        }

    async handleLogoutClick(): Promise<void> {
        await this.props.adminSessionUtil.logout(this.props)
    }

    handleChangeLoginSiteToResidentButtonClick(): void {
        this.props.eventEmitter.showDialog({
            title: `確認`,
            errorLevel: MESSAGE_TYPE.WARNING,
            message: Messages.WOPCR0003.toString('素敵ネット管理用', '素敵ネット'),
            buttonProps: [
                {
                    isDefault: false,
                    buttonLabel: 'キャンセル',
                    buttonHandler: this.handleClickCancelOnDialog,
                },
                {
                    isDefault: false,
                    buttonLabel: 'OK',
                    buttonHandler: this.handleClickOkChangeLoginSiteToResident,
                },
            ],
        })
    }

    async handleClickOkChangeLoginSiteToResident(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.adminSessionUtil.changeLoginSiteToResident(this.props)
    }

    render(): ReactElement {
        const switchingCondominiumGroup = this.getSwitchingCondominiumGroup()
        const showSpModePage = this.context.showSpModePage
        return <>
            {showSpModePage ? <>
                <NatAdminHeaderAreaComponentSp
                    {...this.props}
                    mode={this.state.mode}
                    selectedCondominiumName={this.state.selectedCondominiumName}
                    loginUserInfo={this.state.loginUserInfo}
                    hasValidSubCondominiumGroup={this.hasValidSubCondominiumGroup()}
                    handleClickAllMode={this.handleClickAllMode}
                    handleClickCondominiumMode={this.handleClickCondominiumMode}
                    handleLogoutClick={this.handleLogoutClick}
                    handleClickCondominiumGroupSwitchingLink={this.handleClickCondominiumGroupSwitchingLink}
                    handleChangeLoginSiteToResidentButtonClick={this.handleChangeLoginSiteToResidentButtonClick}
                />
            </> : <>
                <NatAdminHeaderAreaComponentPc
                    {...this.props}
                    mode={this.state.mode}
                    selectedCondominiumName={this.state.selectedCondominiumName}
                    loginUserInfo={this.state.loginUserInfo}
                    hasValidSubCondominiumGroup={this.hasValidSubCondominiumGroup()}
                    handleClickAllMode={this.handleClickAllMode}
                    handleClickCondominiumMode={this.handleClickCondominiumMode}
                    handleLogoutClick={this.handleLogoutClick}
                    handleClickCondominiumGroupSwitchingLink={this.handleClickCondominiumGroupSwitchingLink}
                    handleChangeLoginSiteToResidentButtonClick={this.handleChangeLoginSiteToResidentButtonClick}
                />
            </>}
            {this.state.isOpenDialogSelectCondominium &&
                <NatCondominiumSelectionComponent
                    selectedCondominiumGroupId={this.state.loginUserInfo.loginUserCondominiumGroupId}
                    selectCondominiumType={SELECT_CONDOMINIUM_TYPE.CONDOMINIUM.value}
                    condominiumRepo={this.props.condominiumRepo}
                    condominiumGroupRepo={this.props.condominiumGroupRepo}
                    closeSelectCondominiumDiaLog={this.handleCloseSelectCondominiumDiaLog}
                    setSelectedCondominiumInfo={this.handleSetSelectedCondominiumInfo}
                    eventEmitter={this.props.eventEmitter}
                    navigate={this.props.navigate}
                    location={this.props.location}
                    asyncCallFunction={this.props.asyncCallFunction}
                />
            }
            {this.state.isOpenDialogSelectCondominiumWithSwitchedGroup &&
                switchingCondominiumGroup &&
                <NatCondominiumSelectionComponent
                    selectedCondominiumGroupId={switchingCondominiumGroup.id}
                    selectCondominiumType={SELECT_CONDOMINIUM_TYPE.CONDOMINIUM.value}
                    condominiumRepo={this.props.condominiumRepo}
                    condominiumGroupRepo={this.props.condominiumGroupRepo}
                    closeSelectCondominiumDiaLog={this.handleCloseSelectCondominiumDiaLog}
                    setSelectedCondominiumInfo={this.handleSetSelectedCondominiumInfo}
                    eventEmitter={this.props.eventEmitter}
                    navigate={this.props.navigate}
                    location={this.props.location}
                    asyncCallFunction={this.props.asyncCallFunction}
                    hiddenCancelButton
                />
            }
        </>
    }
}

AdminHeaderAreaComponent.contextType = AppAdminContext

export default withAsyncCommunication(AdminHeaderAreaComponent)
